<template>
  <div class="Footbar bg contact">
    <div class="w">
      <div class="content">
        <!-- <p>互联网药品信息服务资格证书编号：(京)-非经营性-2020-0034</p> -->
        <!-- <p>备案号：京ICP备17058294号-1</p> -->
        <p>公司：河北杏林医药物流有限公司</p>
        <p>地址：河北省石家庄市高新区太行西街113号</p>
        <p>电话：0311-89899849</p>
        <!-- <div class="content" style="display: flex; align-items: center;">
         
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >备案号：冀ICP备2024050157号-1</a
          >
          <div class="beian">
          <img style="width:20xp;  height: 22px;" src="../../assets/images/index/tubiao.png" alt="">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13050302001981" rel="noreferrer" target="_blank">冀公网安备13050302001981</a>
        </div>
        </div> -->
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footbar",
};
</script>

<style scoped>
.bg {
  color: #fff;
  background-image: linear-gradient(to right, #c1c1c1, #6a6a6b);
 
}

.contact {
  padding: 50px 0 30px 0;
  margin-top: 60px;
}

.company {
  margin-right: 50px;
}

.content p {
  margin-bottom: 10px;
}
.content a {
  color: #ffffff;
  margin-right: 10px;
}
.beian {
  display: flex;
  
  /* margin-top: 10px; */

}
.beian img {
  margin-right: 3px;
}

</style>